import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { NewsFeedModule } from '@fi-app/news-feed/news-feed.module';
import { ForumService } from './forum.service';
import { ForumEditComponent } from './forum-edit/forum-edit.component';
import { ComponentsModule } from '../components/components.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';
import { ForumStates } from '@fi-app/forum/forum-states';
import { FiPageHeaderButtonGroupModule } from '@fi-shared/fi-page-header-button-group/fi-page-header-button-group.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';

@NgModule({
    imports: [
        CommonModule,
        UtilitiesModule,
        NewsFeedModule,
        ComponentsModule,
        MatCheckboxModule,
        FormsModule,
        UIRouterModule.forChild(ForumStates),
        FiPageHeaderButtonGroupModule,
        MatIconModule,
        MatButtonModule,
        FiItemsListModule,
    ],
    declarations: [ForumEditComponent],
    providers: [ForumService],
})
export class ForumModule {}
